// httpVueLoader.register(Vue, "components/contact.vue");

// const store = new Vuex.Store({
//   state: {
//     isIe: false,
//     result: null,
//   },
//   mutations: {
//     updateIe(state, payload) {
//       state.isIe = payload;
//     },
//     setData(state, payload) {
//       state.result = payload;
//     },
//   },
//   actions: {
//     getData(context) {
//       axios.get("db.json").then((res) => {
//         context.commit("setData", res.data);
//       });
//     },
//   },
// });

// new Vue({
//   el: "main",
//   components: {
//     ie: httpVueLoader("components/ie.vue"),
//     web: httpVueLoader("components/WB00330201/Wb00330201.vue"),
//   },
//   computed: {
//     isIe() {
//       return store.state.isIe;
//     },
//     result() {
//       return store.state.result;
//     },
//     componentId() {
//       return store.state.isIe ? "web" : "ie";
//     },
//   },
//   methods: {
//     IEVersion() {
//       var userAgent = navigator.userAgent; //取得瀏覽器的userAgent字串
//       var isIE =
//         userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判斷是否IE<11瀏覽器
//       // var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判斷是否IE的Edge瀏覽器
//       var isIE11 =
//         userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
//       if (isIE) {
//         var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
//         reIE.test(userAgent);
//         var fIEVersion = parseFloat(RegExp["$1"]);
//         if (fIEVersion == 7) {
//           return 7;
//         } else if (fIEVersion == 8) {
//           return 8;
//         } else if (fIEVersion == 9) {
//           return 9;
//         } else if (fIEVersion == 10) {
//           return 10;
//         } else {
//           return 6; //IE版本<=7
//         }
//       } else if (isIE11) {
//         return 11; //IE11
//       } else {
//         return -1; //不是ie瀏覽器
//       }
//       // else if(isEdge) {
//       // return 'edge';//edge
//       // }
//     },
//   },
//   created() {
//     this.IEVersion();
//     let ie = this.IEVersion() !== -1 ? false : true;
//     store.commit("updateIe", ie);
//     store.dispatch("getData");
//   },
//   mounted() {
//   },
// });

$(function() {

  $('body').running();

  new WOW().init();

  $(".page-submenubox .tel").replaceWith(
    '<p class="tel"><img src="https://static.digiwin.com.tw/static/images/tel.png">免費諮詢熱線：0809-088-958</p>'
  );

  let swiper = new Swiper(".c2_slides", {
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".c2swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        let title = ['料件供需管理','生產排程管理','生產現場管理','品質追溯管理'];
        return `<div class="${className}  wow fadeInLeftSmall"  data-wow-duration="1s" data-wow-delay=".${index+3}s"><div class="pagination-bullet"><img src="images/WB00330201/c2/c2_icon${index + 1}.png">${title[index]}</div></div>`;
      },
    },
  });

  let swiper3 = new Swiper(".c3_slides", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(document).on("click",".c2_slide",function(){
    $(this).find("h3").addClass("active");
    $(this).siblings().find("h3").removeClass("active")
    $(this).find(".c2_slidetext").slideDown();
    $(this).siblings().find(".c2_slidetext").slideUp();
  })

  enquire.register("screen and (min-width: 769px)", {
    match : function() {
      let swiper2 = new Swiper(".c5_slides", {
        spaceBetween: 15,
        pagination: {
          el: ".c5swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            let title = ['產銷備料管理方案','排程撿料管理方案','現場品質管理方案'];
            return `<div class="${className}"><div>${title[index]}</div></div>`;
          },
        },
      });
    },
  });
    
    
    
    
  enquire.register("screen and (max-width: 768px)", {
    match : function() {
      let swiper2 = new Swiper(".c5_slides", {
        spaceBetween: 15,
        pagination: {
          el: ".c5swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            let title = ['備料<br>管理','排程<br>管理','現場<br>管理'];
            return `<div class="${className}"><div>${title[index]}</div></div>`;
          },
        },
      });
      $(".c2_slide h3").siblings().eq(0).show();
      $(".c2_slide h3").eq(0).addClass("active");
    },
  });

  
});